import React from "react";
import {
	Dialog,
	DialogContent,
	Typography,
	Button,
	Box,
} from "@material-ui/core";
import { CheckCircle } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import MuiStylesCancellationSuccessModal from "./MuiStylesCancellationSuccessModal";

const FeedbackModalDetailsSchedules = ({
	open,
	onClose,
	business,
	history,
	title,
	message,
	confirmSchedule = false,
	cancelSchedule = true,
	alert = false,
}) => {
	const classes = MuiStylesCancellationSuccessModal();
	const { t } = useTranslation();

	if (!open) return null;

	const handleScheduleNew = () => {
		onClose();
		history.push(`/selecionar-data/${business?.id}`);
	};

	const handleViewReservations = () => {
		onClose();
		history.push(`/reservas/${business?.id}`);
	};

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="sm"
			fullWidth
			PaperProps={{
				className: classes.dialogPaper,
			}}
		>
			<DialogContent className={classes.dialogContent}>
				<Box className={classes.headerSection}>
					<Typography className={classes.title}>{title || t("Reservation cancelled")}</Typography>
				</Box>

				<Box className={classes.bodySection}>
					<Typography className={classes.message}>
						{message || t("Your appointment has been cancelled successfully Would you like to schedule a new appointment or view your reservations")}
					</Typography>
				</Box>
			{confirmSchedule && (
				<Box className={classes.actionButtons}>
				<Button
					className={classes.scheduleButton}
					onClick={handleViewReservations}
				>
					{t("OK")}
				</Button>
			</Box>
			)}

			{alert && (
				<Box className={classes.actionButtons}>
					<Button
						className={classes.scheduleButton}
						onClick={onClose}
					>
						{t("OK")}
					</Button>
				</Box>
			)}

			{ cancelSchedule && (
				<Box className={classes.actionButtons}>
					<Button
						className={classes.scheduleButton}
						onClick={handleScheduleNew}
					>
						{t("Schedule new")}
					</Button>
					<Button
						className={classes.viewReservationsButton}
						onClick={handleViewReservations}
					>
						{t("View reservations")}
					</Button>
				</Box>
			)}
			</DialogContent>
		</Dialog>
	);
};

export default withRouter(FeedbackModalDetailsSchedules);
